/** Shared constants and formatters for User Activity. */

export const DEFAULT_ACTIVITY = [
	{ type: 'sessionStart', time: '—', label: 'Session Started', success: true },
	{ type: 'page', time: '—', label: 'No activity', actions: [] },
];

export function formatLocalDateTime(isoOrDate) {
	if (isoOrDate == null) return '—';
	const d = typeof isoOrDate === 'string' ? new Date(isoOrDate) : isoOrDate;
	if (Number.isNaN(d.getTime())) return '—';
	return d.toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' });
}

export function formatLocalTime(isoOrDate) {
	if (isoOrDate == null) return '—';
	const d = typeof isoOrDate === 'string' ? new Date(isoOrDate) : isoOrDate;
	if (Number.isNaN(d.getTime())) return '—';
	return d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', hour12: true });
}

/**
 * Session time range and date for display.
 * Returns { timeRange: "10:15 AM - 11:00 AM" or "10:15 AM - Active", dateStr: "Feb 6, 2025" }.
 */
export function formatSessionTimeRange(accessedAt, endedAt) {
	if (accessedAt == null) return { timeRange: '—', dateStr: '' };
	const start = typeof accessedAt === 'string' ? new Date(accessedAt) : accessedAt;
	if (Number.isNaN(start.getTime())) return { timeRange: '—', dateStr: '' };
	const dateStr = start.toLocaleDateString(undefined, { dateStyle: 'short' });
	const startTimeStr = start.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', hour12: true });
	if (endedAt == null) return { timeRange: `${startTimeStr} - Active`, dateStr };
	const end = typeof endedAt === 'string' ? new Date(endedAt) : endedAt;
	const endTimeStr = Number.isNaN(end.getTime()) ? '—' : end.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', hour12: true });
	return { timeRange: `${startTimeStr} - ${endTimeStr}`, dateStr };
}

/** User-friendly session header message. */
export function formatSessionHeaderMessage(accessedAt, endedAt) {
	if (accessedAt == null) return 'Session started at —';
	const start = typeof accessedAt === 'string' ? new Date(accessedAt) : accessedAt;
	if (Number.isNaN(start.getTime())) return 'Session started at —';
	const startStr = start.toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' });
	if (endedAt == null) return `Session started at ${startStr}.`;
	const end = typeof endedAt === 'string' ? new Date(endedAt) : endedAt;
	const endStr = Number.isNaN(end.getTime()) ? '—' : end.toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' });
	return `Session started at ${startStr} and ended at ${endStr}.`;
}
